// extracted by mini-css-extract-plugin
export default {"background":"Nw01ls_f2_KK7qVG_Cgf"};